import {create} from 'zustand'

const getUserFromLocalStorage = () => {
    const userString = localStorage.getItem('user')
    if (userString) {
        try {
            return JSON.parse(userString)
        } catch (error) {
            console.log('Error parsing user from localStorage:', error)
            return null
        }
    }
    return null
}

const useAuthStore = create((set) => ({
    // isLoggedIn: !!localStorage.getItem('access_token'),
    accessToken: localStorage.getItem('access_token'),
    user: getUserFromLocalStorage(),

    setAccessToken: (accessToken) => {
        localStorage.setItem('access_token', accessToken)
        // set({isLoggedIn: !!accessToken?.length})
        set({accessToken})
    },

    // setIsLoggedIn: (isLoggedIn) => {
    //     !isLoggedIn && localStorage.setItem('access_token', '')
    //     set({isLoggedIn})
    // },

    setUser: (user) => {
        localStorage.setItem('user', JSON.stringify(user))
        set({user})
    },
}))

export default useAuthStore
